<template><div><h1 id="_3-dubletten-und-haushalte-bearbeiten" tabindex="-1"><a class="header-anchor" href="#_3-dubletten-und-haushalte-bearbeiten"><span>3. Dubletten- und Haushalte bearbeiten</span></a></h1>
<h2 id="_3-1-einfuhrung" tabindex="-1"><a class="header-anchor" href="#_3-1-einfuhrung"><span>3.1. Einführung</span></a></h2>
<p>Die Bearbeitung ist unterteilt in die Schritte &quot;Dublettensuche&quot;, &quot;Dublettenzusammenführung&quot; und &quot;Haushaltsbildung&quot;. Diese Prozesse können automatisch in regelmässigen Intervallen oder manuell ausgelöst werden.</p>
<p>Das Ziel ist es Dubletten zu vermeiden und bereits bestehende Dubletten zu erkennen und zu entfernen. Mit der Haushaltsbildung sollen Personen die im selben Haushalt leben erkannt und durch erstellen von Beziehungen als Haushalt definiert werden.</p>
<h3 id="_3-1-1-dublettensuche" tabindex="-1"><a class="header-anchor" href="#_3-1-1-dublettensuche"><span>3.1.1. Dublettensuche</span></a></h3>
<p>Mit dem Job <RouteLink to="/referenz/refs/ft.refproc.doubkandsuch.html" title="Dubletten, Haushalte suchen">Dubletten, Haushalte suchen</RouteLink> können wahlweise Dubletten für eine manuelle Bearbeitung gesucht und klassiert (Treffergenauigkeit &quot;sehr hoch&quot;,&quot;hoch&quot;) werden oder eindeutige Dubletten gleich markiert und zusammengeführt werden. Weiter können Haushalte automatisch erkannt und gebildet werden.</p>
<h3 id="_3-1-2-dublettenzusammenfuhrung" tabindex="-1"><a class="header-anchor" href="#_3-1-2-dublettenzusammenfuhrung"><span>3.1.2. Dublettenzusammenführung</span></a></h3>
<p>Mit dem Job <RouteLink to="/referenz/refs/ft.refproc.cleanmarkdoub.html" title="Markierte Dubletten zusammenführen">Markierte Dubletten zusammenführen</RouteLink> werden Dubletten zu einer Person zusammengeführt.</p>
<h3 id="_3-1-3-manuelle-bearbeitung" tabindex="-1"><a class="header-anchor" href="#_3-1-3-manuelle-bearbeitung"><span>3.1.3. Manuelle Bearbeitung</span></a></h3>
<p>In der Ansicht <RouteLink to="/referenz/refs/ft.refdata.doubkandmanbearb.html" title="Manuelle Bearbeitung">Manuelle Bearbeitung</RouteLink> können alle möglichen Dubletten und Haushalte manuell verknüpft werden.</p>
<h3 id="_3-1-4-haushalterkennung" tabindex="-1"><a class="header-anchor" href="#_3-1-4-haushalterkennung"><span>3.1.4. Haushalterkennung</span></a></h3>
<p>Die Methoden für die Erkennung von Haushalten ist bis auf den Vergleich der Vornamen identisch wie für die Dublettenerkennung.</p>
<h3 id="_3-1-5-dublettenerkennung" tabindex="-1"><a class="header-anchor" href="#_3-1-5-dublettenerkennung"><span>3.1.5. Dublettenerkennung</span></a></h3>
<p>Im Flussdiagramm am Schkuss ist aufgezeigt, wie das System eine Person mit postalischer Adresse als Dublette erkennt.</p>
<h4 id="_3-1-5-1-personen-ohne-postalische-adressen-mobile-only" tabindex="-1"><a class="header-anchor" href="#_3-1-5-1-personen-ohne-postalische-adressen-mobile-only"><span>3.1.5.1. Personen ohne postalische Adressen (&quot;Mobile only&quot;)</span></a></h4>
<p>Personen ohne postalische Adressen werden, gem. folgenden Kritrien automatisch als Dubletten erkannt:</p>
<ul>
<li>
<p>die Adressen (E-Mail, Telefonnummer) müssen identisch sein</p>
</li>
<li>
<p>es werden Personendaten (Typ, Vorname, Name, Geburtsdatum, Geschlecht, Titel) und die Daten der postalischen Standardadresse (Land, PLZ, Ort, Strasse, Hausnummer) miteinander verglichen. Wenn bei einem der beiden Kandidaten Daten nicht vorhanden sind (z. B. keine postalische Adresse), gilt das als identischer Eintrag. Kleinere Abweichungen führen zu einer Reduktion der Wertung. Z.B. &quot;H.&quot; statt &quot;Hans&quot; im Vornamen wird nicht mehr als &quot;sehr hoch&quot; gewertet und somit auch nicht automatisch zusammengeführt.</p>
</li>
</ul>
<p>Nachfolgend 4 Beispiele:</p>
<p><strong>Person A mit E-Mail + Vor- Nachname und Person B mit Vor-/Nachname, E-Mail abweichend:</strong></p>
<table>
<thead>
<tr>
<th>1. Person</th>
<th>2. Person</th>
<th>gleich?</th>
</tr>
</thead>
<tbody>
<tr>
<td>Hans Muster</td>
<td>Hans Muster</td>
<td>ja</td>
</tr>
<tr>
<td>h.muster@bluewin.ch</td>
<td>hans.muster@bluewin.ch</td>
<td>nein</td>
</tr>
</tbody>
</table>
<p><em>Resultat: keine Dublette</em></p>
<p><strong>Person A mit Name, post. Adresse und Person B nur mit E-Mail:</strong></p>
<table>
<thead>
<tr>
<th>1. Person</th>
<th>2. Person</th>
<th>gleich?</th>
</tr>
</thead>
<tbody>
<tr>
<td>Hans Muster</td>
<td></td>
<td>ja</td>
</tr>
<tr>
<td>Bahnhofstrasse 3</td>
<td></td>
<td>ja</td>
</tr>
<tr>
<td>3604 Thun</td>
<td></td>
<td>ja</td>
</tr>
<tr>
<td>h.muster@bluewin.ch</td>
<td>h.muster@bluewin.ch</td>
<td>ja</td>
</tr>
</tbody>
</table>
<p><em>Resultat: Vorschlag &quot;mögliche Dublette&quot;/&quot;sehr hoch&quot;, automatische Zusammenführung möglich</em></p>
<p><strong>Person A mit E-Mail + Vor-/Nachname und Person B mit E-Mail + Vor-/Nachname:</strong></p>
<table>
<thead>
<tr>
<th>1. Person</th>
<th>2. Person</th>
<th>gleich?</th>
</tr>
</thead>
<tbody>
<tr>
<td>Hans Muster</td>
<td>Hans Muster</td>
<td>ja</td>
</tr>
<tr>
<td>h.muster@bluewin.ch</td>
<td>h.muster@bluewin.ch</td>
<td>ja</td>
</tr>
</tbody>
</table>
<p><em>Resultat: Vorschlag &quot;mögliche Dublette&quot;/&quot;sehr hoch&quot;, automatische Zusammenführung möglich</em></p>
<p><strong>Person A mit Name, post. Adresse und Person B mit E-Mail + Vorname gekürzt und Nachname:</strong></p>
<table>
<thead>
<tr>
<th>1. Person</th>
<th>2. Person</th>
<th>gleich?</th>
</tr>
</thead>
<tbody>
<tr>
<td>Hans Muster</td>
<td>H. Muster</td>
<td>nein</td>
</tr>
<tr>
<td>Bahnhofstrasse 3</td>
<td></td>
<td>ja</td>
</tr>
<tr>
<td>3604 Thun</td>
<td></td>
<td>ja</td>
</tr>
<tr>
<td>h.muster@bluewin.ch</td>
<td>h.muster@bluewin.ch</td>
<td>ja</td>
</tr>
</tbody>
</table>
<p><em>Resultat: Vorschlag &quot;mögliche Dublette&quot;/&quot;tief&quot;, keine automatische Zusammenführung</em></p>
<p><img src="@source/manual/customer/i/3_dublettensuche.jpg" alt="Dublettensuche"></p>
</div></template>


